<template>
  <v-container v-if="this.zamawiajacy" class="page">
<table>
  <thead>
  <tr><td>

<div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
  <div class="left-cointainer">
    <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
  </div>
  <div class="right-cointainer">
    Tutore Poland Sp. z o.o.<br>
    ul. Piotrkowska 157A, 90-440 Łódź<br>
    NIP: 7272812193
  </div>
</div>

  </td></tr>
  </thead>
<tbody>
<tr><td>

<p align="center" style="margin-top:20px;">
    <strong>Aneks do umowy zlecenie z dnia {{datazdnia}}</strong>
</p>
<p>
    Zawarty w dniu {{(new Date().toJSON().slice(0, 10).replace(/(\d+)-(\d+)-(\d+)/, '$3-$2-$1'))}} w Łodzi pomiędzy:
</p>
<p>
  <strong>Tutore Poland Sp. z o.o.</strong>, z siedzibą w Łodzi 
  przy ul. Piotrkowska 157A, 90-440 Łódź, wpisaną 
  do Rejestru Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego
  przez Sąd Rejonowy dla Łodzi Śródmieścia, XX Wydział Krajowego Rejestru Sądowego 
  pod nr KRS: 0000670834, NIP: 727-28-12-193, REGON: 366891567, o kapitale
  zakładowym w wysokości 1 664 600,00 zł, reprezentowaną przez: 
</p>
<p>
  <strong>{{zamawiajacy}}</strong>, zwaną w dalszej części Umowy <strong>Zleceniodawcą</strong>
</p>
<p>
  a​ Zleceniobiorcą:
  <br/>
  Imię i nazwisko: {{imieNazwisko}}
  <br/>
  PESEL: {{pesel}}
  <br/>
  adres zamieszkania: {{zamieszkany}}
</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 1</strong>
</p>
<p>
  Strony zgodnie postanawiają, że od dnia 2 stycznia 2020 r. zmianie ulega § 3 pkt 1. dotyczący wynagrodzenia Zleceniobiorcy na następującą treść: 
<ol>
<li>
Tytułem wynagrodzenia Zleceniobiorca otrzyma kwotę w wysokości 13 zł brutto (słownie złotych: trzynaście) 
za 1 godzinę lekcyjną zajęć, trwającą 45 minut. Zleceniobiorca może podwyższyć wynagrodzenie 
za każdy miesiąc wykonywania Umowy do kwoty 14 zł brutto (słownie złotych: czternaście) za 1 godzinę lekcyjną zajęć, 
trwającą 45 minut, po spełnieniu poniższych kryteriów:
</li>
<ol type="a">
<li>
prowadzenie zajęć edukacyjnych ściśle wg wytycznych organizacyjnych i merytorycznych określonych 
przez Zleceniobiorcę,
</li>
<li>
wypełnianie list obecności zawsze i bez wyjątku tego samego dnia, w którym odbywają się zajęcia,
</li>
<li>
terminowe wypełnianie innych raportów określonych przez Zleceniodawcę,
</li>
<li>
terminowe rozdawanie i podpisywanie w imieniu Zleceniodawcy umów na świadczenie usług edukacyjnych 
oraz ich dostarczanie w określonym przez Zleceniobiorcę czasie,
</li>
<li>
dostarczanie drogą pocztową lub e-mailową dokumentów dotyczących Zleceniodawcy niezwłocznie, 
w jak najkrótszym terminie,
</li>
<li>
wypełniania innych wytycznych organizacyjnych na bieżąco przekazywanych przez Zleceniobiorcę 
w trakcie wykonywania Umowy,
</li>
<li>
brak spóźnień i nie popartych zwolnieniem lekarskim absencji na zajęciach edukacyjnych 
w trakcie okresu rozliczeniowego,
</li>
<li>
wykonywanie wszystkich wytycznych określonych w § 2 niniejszej Umowy.
</li>
</ol>
</ol>
</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 2</strong>
</p>
<p>Pozostałe warunki umowy pozostają bez zmian.</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 3</strong>
</p>
<p>
  Niniejszy aneks  został sporządzony w dwóch jednobrzmiących egzemplarzach, po jednym dla każdej ze stron.
</p>
<div class="cointainer" style="margin-top: 20px; margin-bottom: 10px;">
  <div class="left-cointainer">
    {{zamawiajacy}}<br>
    <span class="caption">(Zleceniodawca)</span>
  </div>
  <div class="right-cointainer">
    {{imieNazwisko}}<br>
    <span class="caption">(Zleceniobiorca)</span>
  </div>
</div>
</td></tr>
</tbody></table>
  </v-container>
</template>

<script>
export default {
  name: 'UmowaGitaraAneks',
  props: {
  },
  data () {
    return {
      zamawiajacy: '',
      imieNazwisko: '',
      zamieszkany: '',
      pesel: '',
      datazdnia: ''
    }
  },
  created () {
    Object.entries(this.$route.query).forEach(
      ([key, value]) => { this[key] = value }
    )
  },
  methods: {
  },
  mounted () {
    if (this.zamawiajacy) {
      this.$nextTick(() => {
        window.setTimeout(() => window.print(), 300)
      })
    }
  }
}
</script>

<style scoped>
.page {
  size: 210mm 290mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 0px;
  padding-top: 0px;
}
table, th, td {
  border: 1px;
  border-collapse: collapse;
}
.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.cointainer-left {
  width: 20%;
}
.cointainer-right {
  width: 20%;
}
thead {
  display: table-header-group;
}
.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}
.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/UmowaGitaraAneks.vue